import './styles.scss';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroll-component';
import {} from 'src/validations';
import { IAppState } from 'src/store';
// import { Toastify } from 'src/services';
import { Input, View, Button, Text, Checkbox } from 'src/components/common';
import './styles.scss';
import { Modal } from 'src/components/Modal';
import { People, getUserName } from 'src/dataFactory/depositionFactory';

import InvolvedPartiesToAdd from './InvolvedParties';
import { usersActions } from 'src/redux/usersRedux';
import PartyPlaceholder from './PartyPlaceholder';
import { validateParties } from '../../helper';
const PAGE_SIZE = 10;

const AddParties: React.FC<Props> = ({ onClose, onSaveData, onGetUsers, addedParties }) => {
  const [searchText, setSearchText] = useState('');
  const [parties, setParties] = useState<People[]>([]);
  const [selectedParties, setSelectedParties] = useState<People[]>(addedParties ?? []);
  const [skipUser, setSkipUser] = useState(0);
  const [total, setTotal] = useState<number>(0);

  useEffect(() => {
    if (addedParties) setSelectedParties(addedParties);
  }, [addedParties]);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = (skip?: number) => {
    handleGetUser({ skip: skip ?? skipUser, take: PAGE_SIZE, search: encodeURIComponent(searchText) });
  };
  const handleGetUser = (params: any) => {
    onGetUsers(params, (res: any) => onGetUsersSuccess(params, res), onGetUsersFailed);
  };
  const onGetUsersSuccess = (params: any, res: any) => {
    const convertData: People[] = res.users.map((user: any) => ({
      id: user.id,
      firstName: user.firstName,
      email: user.email,
      lastName: user.lastName,
      position: user.role,
      imageURL: 'https://picsum.photos/200/400',
      name: getUserName(user),
      companyOrLawFirm: user.companyOrLawFirm,
    }));

    if (params.skip === 0) {
      setParties(convertData);
      setTotal(res.total);
      setSkipUser(skipUser => skipUser + PAGE_SIZE);
    } else {
      setParties(parties => parties.concat(convertData));
      setSkipUser(skipUser => skipUser + PAGE_SIZE);
    }
  };
  const onGetUsersFailed = (_err: any) => {};

  const handleChange = (e: any, user: People) => {
    var updatedParties = selectedParties;
    if (selectedParties.some(d => d.id === user.id)) {
      updatedParties = updatedParties.filter(item => item.id !== user.id);
      setSelectedParties(updatedParties);
    } else {
      setSelectedParties(parties => parties.concat(user));
    }
    const checked = e.target.checked;
    const updatedData = parties.map(party =>
      party.id === user.id
        ? {
            ...party,
            isSelected: checked,
          }
        : party,
    );
    setParties(updatedData);
  };
  const isChecked = (id: string) => {
    return selectedParties.some(p => p.id === id);
  };
  const handleInputChange = (params: any) => {
    setSearchText(params.target.value);
  };

  const handleSearchUser = () => {
    fetchData(0);
    setSkipUser(0);
  };
  const handleSubmitData = () => {
    onSaveData(selectedParties);
  };
  const error = validateParties(selectedParties);
  return (
    <Modal onModalClosed={onClose} modalContainerClassName={'ctn-add-party'}>
      <Text variant="title">Add Parties</Text>
      <View className="mt-20 add-parties">
        <Input
          placeholder="Search User by Name, Email or Company/Law firm"
          name="search"
          value={searchText}
          onChange={handleInputChange}
          onBlur={() => {}}
          errorMessage={''}
          containerClassName="mb-16"
          style={{ borderRadius: '8px' }}
          iconName="ic_search"
          onIconClick={() => handleSearchUser()}
          onKeyDown={event => {
            if (event.key === 'Enter') {
              event.preventDefault();
              handleSearchUser();
            }
          }}
        />
        <Text size={14} className={'mb-16'}>
          <i>* Parties should have one Court Reporter and at least one Client.</i>
        </Text>
        <View id="scrollableDiv" className={'ctn-add-party__users'}>
          <InfiniteScroll
            dataLength={parties.length}
            next={fetchData}
            hasMore={parties.length < total}
            loader={
              <React.Fragment>
                <PartyPlaceholder />
                <PartyPlaceholder />
                <PartyPlaceholder />
                <PartyPlaceholder />
              </React.Fragment>
            }
            scrollableTarget="scrollableDiv"
            endMessage={null}>
            <View style={{ overflow: 'auto' }}>
              {parties.map(party => (
                <View isRow style={{ flexWrap: 'nowrap' }}>
                  <Checkbox.Item
                    onChange={e => handleChange(e, party)}
                    checked={isChecked(party.id)}
                    name={party.id + ''}
                  />
                  <InvolvedPartiesToAdd user={party} />
                </View>
              ))}
            </View>
          </InfiniteScroll>
        </View>
        <View isRow justify="flex-end" className="mt-24">
          <Button onClick={onClose} variant="secondary-outline">
            CANCEL
          </Button>
          {selectedParties.length > 0 && (
            <Button
              disabled={!!error}
              type="button"
              onClick={() => handleSubmitData()}
              variant="secondary"
              className="ml-20">
              {`ADD ${selectedParties.length} ${selectedParties.length < 2 ? 'PARTY' : 'PARTIES'} `}
            </Button>
          )}
        </View>
      </View>
    </Modal>
  );
};

type Props = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps & {
    onClose: () => void;
    onSaveData: (data: People[]) => void;
    addedParties?: People[];
  };
const mapStateToProps = (state: IAppState) => ({});

const mapDispatchToProps = {
  onGetUsers: usersActions.getUsers,
};
export default connect(mapStateToProps, mapDispatchToProps)(AddParties);
